import { DOMAIN_TYPES } from './domainTypes';

export const DOMAIN_ACCESS_GROUPS = Object.freeze({
  ASSESSMENT_EDUCATION: Object.freeze([DOMAIN_TYPES.ASSESSMENT, DOMAIN_TYPES.EDUCATION]),
  ASSESSMENT_ONLY: Object.freeze([DOMAIN_TYPES.ASSESSMENT]),
  EDUCATION_FLEX: Object.freeze([DOMAIN_TYPES.EDUCATION, DOMAIN_TYPES.FLEX_OFFICE]),
  EDUCATION_INSTITUTION: Object.freeze([DOMAIN_TYPES.EDUCATION, DOMAIN_TYPES.INSTITUTION]),
  EDUCATION_ONLY: Object.freeze([DOMAIN_TYPES.EDUCATION]),
  EDUCATION_RETAIL: Object.freeze([DOMAIN_TYPES.EDUCATION, DOMAIN_TYPES.RETAIL]),
  FLEX_EDUCATION_RETAIL: Object.freeze([DOMAIN_TYPES.FLEX_OFFICE, DOMAIN_TYPES.EDUCATION, DOMAIN_TYPES.RETAIL]),
  FLEX_EDUCATION_RETAIL_KRUMAGO: Object.freeze([DOMAIN_TYPES.FLEX_OFFICE, DOMAIN_TYPES.EDUCATION, DOMAIN_TYPES.RETAIL, DOMAIN_TYPES.KRUMAGO]),
  FLEX_OFFICE_ONLY: Object.freeze([DOMAIN_TYPES.FLEX_OFFICE]),
  FLEX_SERVICES: Object.freeze([DOMAIN_TYPES.FLEX_OFFICE, DOMAIN_TYPES.SERVICES]),
  INSTITUTION_ONLY: Object.freeze([DOMAIN_TYPES.INSTITUTION]),
  PUBLIC_INVOICE_PAYMENT: Object.freeze([
    DOMAIN_TYPES.KRUMAGO,
    DOMAIN_TYPES.EDUCATION,
    DOMAIN_TYPES.FLEX_OFFICE,
    DOMAIN_TYPES.RETAIL,
    DOMAIN_TYPES.SERVICES,
    DOMAIN_TYPES.WAAS,
  ]),
  KRUMAGO_ONLY: Object.freeze([DOMAIN_TYPES.KRUMAGO]),
  // Krumago's public header links to the marketing landing pages for each
  // industry. Those pages are rendered by the Krumago route tree when the
  // visitor is on the Krumago domain.
  KRUMAGO_INDUSTRIES: Object.freeze([DOMAIN_TYPES.KRUMAGO]),
  // Education students pay their course fee bill through the same OTP gated
  // payment page Krumago already uses.
  KRUMAGO_EDUCATION: Object.freeze([DOMAIN_TYPES.KRUMAGO, DOMAIN_TYPES.EDUCATION]),
  RETAIL_ONLY: Object.freeze([DOMAIN_TYPES.RETAIL]),
  WAAS_ONLY: Object.freeze([DOMAIN_TYPES.WAAS]),
});

export const TEMPLATE_AUTH_DOMAIN_TYPES = Object.freeze([
  DOMAIN_TYPES.EDUCATION,
  DOMAIN_TYPES.RETAIL,
  DOMAIN_TYPES.FLEX_OFFICE,
  DOMAIN_TYPES.WAAS,
]);
